import React from "react"
import { NavLink } from "react-router-dom"

import * as Icons from "../assets/icons"
import { phone, email } from "../data/Contact"

const SideContact = () => (
  <div className="side-contact">
    <h3>Masz pytania?</h3>
    <p>Skontaktuj się z nami – pierwsza konsultacja jest bezpłatna.</p>
    <a href={phone.href} className="button button-primary">
      <Icons.Phone /> {phone.display}
    </a>
    <a href={`mailto:${email}`} className="side-contact-link">
      <Icons.Contact /> {email}
    </a>
    <NavLink to="/kontakt" className="side-contact-link">
      <Icons.ArrowRight /> Formularz kontaktowy
    </NavLink>
  </div>
)

export default SideContact
